import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PwdReset_Request.html?raw';
import Edit from '../../UI/Edit/Edit';
import "../../UI/Edit/Edit";
import Button from '../../UI/Button/Button';
import "../../UI/Button/Button";
//import DataItems = require("DataItems");


class PwdReset_Request extends compose(_WidgetBaseSP) {
    templateString: any = template;

    emailInput: MdsLax<InstanceType<typeof Edit>>;
    requestButton: MdsLax<InstanceType<typeof Button>>;

    // diverse Node:
    sectionInputForm: HTMLDivElement;
    sectionRequestComplete: HTMLDivElement;
    sectionErrorMessage: HTMLDivElement;
    txtErrorMessage: HTMLSpanElement;
    txtRequestCompleteMessage: HTMLParagraphElement;

    sendRequest() {
        this.StandbyStart();

        this.RequestManager.post(window.appRoot + "Password/SendRequest",
            {
                "emailAddress": this.emailInput.getValue()
            },
            lang.hitch(this, this._onSendRequestResponse),
            lang.hitch(this, this._onSendRequestError),
            false            
        );
    }

    _onSendRequestResponse(response: object): void {
        this.StandbyStop();
        //console.log("_onSendRequestResponse", response);

        this.showErrorMessage("");

        this.UiModder.domClass.add(this.sectionInputForm, "w3-hide");
        this.UiModder.domClass.remove(this.sectionRequestComplete, "w3-hide");
    }

    _onSendRequestError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        this.showErrorMessage(error.Message);
        console.error("_onSendRequestError", error.url, error.Message);
    }

    _onValueChange_EmailInput(value?: any) {
        //console.debug("_onValueChange_EmailInput", value);

        if (this.emailInput.getValue() == "" || this.emailInput.getValue() == null) {
            this.requestButton.setReadonly(true);
        } else {
            this.requestButton.setReadonly(false);
        }
    }

    _onClick_SendRequest(data?: any) {
        // input prüfen!
        if (this.emailInput.getValue() == "" || this.emailInput.getValue() == null) {
            return;
        }

        // ist Email??
        // TODO!
        this.sendRequest();
    }

    showErrorMessage(message?: string) {
        if (message == null || typeof (message) == "undefined" || message == "") {
            this.txtErrorMessage.textContent = "";
            this.UiModder.domClass.add(this.sectionErrorMessage, "w3-hide");
        } else {
            this.txtErrorMessage.textContent = message;
            this.UiModder.domClass.remove(this.sectionErrorMessage, "w3-hide");
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // hmm, unschön: wir bekommen nicht vorgeschlagen, dass das Input diesen Emitter hat  

        this.txtRequestCompleteMessage.innerHTML = this.translations["PwdReset__Request_CompleteMessage"];
        
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(PwdReset_Request);